module.exports = __webpack_public_path__ + "img/icon_arrow down.d08e43d2.svg";